<template>
  <page-wrapper :title="title">
    <tier-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></tier-list-item>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import TierListItem from "../components/TierListItem";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    TierListItem
  },
  data() {
    const title = "Tier Ruejai Club";
    const list = [];

    return {
      title,
      list
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.ruejaiClub.tiers.list();

      return response.data.result.items.map(item => {
        return {
          id: item.id,
          name: item.name,
          route: { name: "RuejaiClubTierDetailPage", params: { id: item.id } },
          packageCount: item.packages.length
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/tier/pages/RuejaiClubTierListPage.vue